<template>
  <div class="mainbody">
    <div class="edit_devi" v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>设备管理</el-breadcrumb-item>
          <el-breadcrumb-item>编辑设备</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="设备信息" name="account">
            <div class="tab-content">
              <el-form
                ref="editForm1"
                :model="model"
                :rules="rules"
                :label-position="labelPosition"
                label-width="120px"
              >
                <el-form-item label="所属客户">
                  <cn-select-search
                    ref="child"
                    v-model="model.companyId"
                    :v_disabled="disabled"
                    :data="companyList"
                    @val="setCompanyId"
                    placeholder="请筛选客户..."
                  >
                  </cn-select-search>
                </el-form-item>

                <el-form-item prop="cabinetCode" label="设备编号">
                  <el-input
                    v-model="model.cabinetCode"
                    placeholder="唯一，不可重复"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="cabinetName" label="设备标签">
                  <el-input
                    v-model="model.cabinetName"
                    placeholder=""
                  ></el-input>
                </el-form-item>

                <el-form-item prop="modelId" label="设备型号">
                  <el-select
                    v-model="model.modelId"
                    :disabled="disabled"
                    placeholder="请选择..."
                  >
                    <el-option
                      v-for="role in modelList"
                      :key="role.id"
                      :label="role.modelName"
                      :value="role.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item prop="address" label="安装地址">
                  <el-input v-model="model.address" placeholder=""></el-input>
                </el-form-item>

                <el-form-item label="标记">
                  <el-input
                    type="text"
                    style="width: 50%; margin-right: 5px"
                    ref="searchText"
                    id="searchText"
                    v-model="keyword"
                    @input="keyUpSearch"
                    placeholder="请输入地址关键字后搜索"
                  >
                  </el-input>

                  <div
                    class="address_items"
                    id="address_result"
                    v-if="searchData.length > 0"
                  >
                    <div
                      class="address_item"
                      v-for="(item, index) in searchData"
                      :key="index"
                      @click="selectAddress(item)"
                    >
                      <b>{{ item.name }}</b>
                      <span
                        >{{ item.pname }}{{ item.cityname
                        }}{{ item.address }}</span
                      >
                    </div>
                  </div>

                  <!-- <div id="temp" style="display: none;"></div> -->
                  <el-card class="table-card" id="amap">
                    <el-amap
                      vid="amap"
                      class="amap"
                      :zoom="zoom"
                      :center="center"
                      :events="mapEvents"
                    >
                      <el-amap-marker
                        vid="component-marker"
                        v-for="marker in markers"
                        :position="marker.position"
                        :key="marker.id"
                      ></el-amap-marker>
                    </el-amap>
                  </el-card>
                </el-form-item>

                <el-form-item prop="lat" label="坐标lat" v-show="false">
                  <el-input
                    v-model="model.lat"
                    placeholder="必填lat"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="lng" label="坐标lng" v-show="false">
                  <el-input
                    v-model="model.lng"
                    placeholder="必填lng"
                  ></el-input>
                </el-form-item>

                <el-form-item label="状态">
                  <el-radio-group v-model="model.state">
                    <el-radio-button label="0">空闲</el-radio-button>
                    <el-radio-button label="4">故障</el-radio-button>
                    <el-radio-button label="5">维修</el-radio-button>
                  </el-radio-group>
                </el-form-item>

                <el-form-item prop="remoteCode" label="远程编码">
                  <el-input
                    v-model="model.remoteCode"
                    placeholder=""
                  ></el-input>
                </el-form-item>

                <el-form-item prop="iotCardNo" label="物联卡号">
                  <el-input v-model="model.iotCardNo" placeholder=""></el-input>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="footer-box">
        <div class="footer-btn">
          <el-button type="primary" @click="submitForm('editForm')"
            >确认保存</el-button
          >
          <el-button plain @click="resetForm">取消返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../js/upload.component.js";
import "../../js/select.component.js";
import { AxiosAjax, getModelData, getCompanyData } from "../../js/axios.config";
import TextCenter from "@/components/Login/teText.vue";

let self = this;
export default {
  components: {
    TextCenter,
  },
  data() {
    return {
      keyword: "",
      disabled: true,
      activeName: "account", //当前选项卡
      labelPosition: "right", //表单对齐方式
      companyList: [], //公司列表
      modelList: [],
      searchData: [], //地图搜索
      model: {
        gmtCreate: "2022-02-10 13:39:52",
        createdBy: "system",
        modifiedBy: "system",
        gmtModified: "2022-02-14 16:56:00",
        id: "",
        companyId: "",
        cabinetCode: "",
        cabinetName: "",
        modelId: "",
        modelName: "",
        svrIp: null,
        svrPort: null,
        address: "",
        lng: 0.0,
        lat: 0.0,
        state: 0,
        model: "",
        online: 0,
        auditTime: null,
        auditor: null,
        remark: null,
        softVer: "",
        commVer: "",
        power: null,
        faultCode: null,
        feeConfigId: null,
        companyName: "",
        fullCompanyName: null,
        remoteCode: "",
        iotCardNo: "",
      },
      rules: {
        companyId: [{ required: true, message: "必填项", trigger: "blur" }],
        cabinetCode: [{ required: true, message: "必填项", trigger: "blur" }],
        modelId: [{ required: true, message: "必填项", trigger: "blur" }],
      },
      zoom: 16, //初始化地图显示层级
      center: [114.057922, 22.543518], //地图中心点坐标
      markers: [{ position: [114.057922, 22.543518] }],
      mapEvents: {
        init(o) {
          //console.log(o.getCenter());
        },
        zoomchange: (e) => {
          //console.log(e);
        },
        zoomend: (e) => {
          //获取当前缩放zoom值
          //console.log(e);
        },
        click: (e) => {
          let { lng, lat } = e.lnglat;
          ve.markers = [{ position: [lng, lat] }];
          ve.model.lat = lat;
          ve.model.lng = lng;
        },
      },
    };
  },
  methods: {
    //初始化数据
    initData: function () {
      let _this = this; //当前页面
      let id = _this.$route.query.id; //获取ID
      if (id) {
        AxiosAjax({
          url: "/cabinet/cabinet/" + id,
          loading: true,
          success: function (res) {
            //赋值给model
            Object.keys(_this.model).forEach((key) => {
              _this.model[key] = res.data.data[key];
            });
            _this.markers = [{ position: [_this.model.lng, _this.model.lat] }];
            _this.center = [_this.model.lng, _this.model.lat];
            _this.$refs.child.valueId = _this.model.companyId;
            _this.$refs.child.reset();
          },
        });
      } else {
        _this.model.companyId =
          window.localStorage.getItem("fx_login_companyId");
      }
      _this.modelList = getModelData();
      _this.companyList = getCompanyData();
      // //地图
      // VueAMap.initAMapApiLoader({
      //     key: '195a644053ff99d3fe7e01233bcb7f98',
      //     plugin: [
      //         'AMap.PlaceSearch', 'AMap.Geolocation'
      //         ],
      //     // 默认高德 sdk 版本为 1.4.4
      //     v: '1.4.4'
      // });
      if (window.localStorage.getItem("fx_login_companyType") == "0") {
        _this.disabled = false;
      }
    },
    submitForm: function () {
      let _this = this; //当前页面
      //多个表单验证
      const f1 = new Promise((resolve, reject) => {
        _this.$refs["editForm1"].validate((valid) => {
          if (valid) resolve();
        });
      });

      Promise.all([f1]).then(() => {
        //提交表单,Id大于0则修改，否则添加
        if (_this.model.id > "0") {
          AxiosAjax({
            method: "put",
            url: "/cabinet/cabinet/update",
            data: _this.model,
            loading: true,
            successMsg: "修改设备成功",
            success: function (res) {
              //可跳转加列表页
              _this.$router.push({ name: "CabinetCabinetList" });
            },
          });
        } else {
          AxiosAjax({
            method: "post",
            url: "/cabinet/cabinet/save",
            data: _this.model,
            loading: true,
            successMsg: "新增设备成功",
            success: function (res) {
              //重置表单
              //_this.$refs['editForm1'].resetFields();
              //可跳转加列表页
              _this.$router.push({ name: "CabinetCabinetList" });
            },
          });
        }
      });
    },
    //跳转链接
    linkUrl: function (url) {
      this.$router.push({ name: "CabinetCabinetEdit", params: { id: url } });
      // window.location.href = url;
    },
    resetForm() {
      window.history.back(-1);
    },
    keyUpSearch() {
      var _this = this;
      var txt = _this.keyword; //this.$refs.searchText.value;
      if (txt) {
        AMap.service(["AMap.PlaceSearch"], function () {
          var placeSearch = new AMap.PlaceSearch({
            //构造地点查询类
            pageSize: 12,
            pageIndex: 1,
            type: _this.keytype,
            city: "深圳", //城市
            cityLimit: "true",
            panel: "temp", //搜索结果的展示面板对元素id，不知道为什么一定要有该参数，最终获取的结果才更完整，参数更多跟完整。所以我在页面随便写了一个<div id="temp" style="display:none"></div>
          });
          //关键字查询
          placeSearch.search(txt, function (status, result) {
            if (status == "complete" && result.info == "OK") {
              //这里可以console.log(result)，查看所有返回的参数，遍历展示这些基本的，我就不赘述
              _this.searchData = result.poiList.pois;
            }
          });
        });
      } else {
        _this.searchData = [];
      }
    },
    selectAddress(item) {
      // 选中后执行，根据自己业务选择
      ve.markers = [{ position: [item.location.lng, item.location.lat] }];
      ve.model.lat = item.location.lat;
      ve.model.lng = item.location.lng;

      ve.center = [item.location.lng, item.location.lat];
      ve.model.address = item.pname + item.cityname + item.address;
      ve.keyword = "";
      ve.searchData = [];
    },
    setCompanyId: function (obj) {
      this.model.companyId = obj.toString();
    },
  },
  created: function () {
    //初始化数据
    this.initData();
  },
  mounted: function () {
    var _this = this;
    _this.$refs.child.valueId = _this.model.companyId;
    _this.$refs.child.reset();
  },
};
</script>
<style scoped>
.el-form-item .table-card {
  height: 300px;
  margin-top: 10px;
}
.el-form-item .el-card__body {
  height: 100%;
}
.address_items {
  width: 300px;
  position: absolute;
  z-index: 999;
  background: #fff;
  overflow: auto;
  max-height: 200px;
}
.address_item {
  width: 600px;
}
.edit_devi >>> .el-form-item__content {
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Cabinet/CabinetEdit.vue